export default __webpack_public_path__ + "static/media/jen.33e72b81.jpg";